import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";

import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import ClassInfoAndFormContainer from "../../../../components/PagesComponents/Setting/Profile/SetupCLasses/ClassInfoAndFormContainer.component";

const Body = ({
  genderWaysFilter,
  setGenderWaysFilter,
  classInfoData,
  handelEdit,
  handelDeleteData
}) => {
  return (
    <div className="flex-col align-left justify-start g-1 w-full">
      <Helmet>
        <title>Setup-Classes</title>
      </Helmet>
      <PageHeader title={"Set up classes with capacity"} />
      <div className="flex-col align-left justify-start g-1 w-full">
        <div className="flex-col align-left justify-start g-1 w-full radius-6 back-white p-2 overflow-hide">
          <h3 className="poppins-medium weight-500 t-16 color-grayColor">
            Choose any type where you want to add classes
          </h3>
          <div className="flex-row align-center justify-start w-full">
            <div
              className="flex-row align-center justify-start g-05"
              style={{ flexWrap: "wrap" }}
            >
              <TogglePushBtn
                type="radio"
                setVal={(val) => setGenderWaysFilter(val)}
                name="examreportToggle"
                value={genderWaysFilter}
                icon={
                  <PersonIcon
                    fill="white"
                    style={{ width: "1.3rem", height: "1.3rem" }}
                  />
                }
                icontype="svg"
                label="All"
              />
              <TogglePushBtn
                type="radio"
                setVal={(val) => setGenderWaysFilter(val)}
                name="examreportToggle"
                value={genderWaysFilter}
                icon={
                  <PersonInMobileIcon
                    fill="white"
                    style={{ width: "1.3rem", height: "1.3rem" }}
                  />
                }
                icontype="svg"
                label="Boys"
              />
              <TogglePushBtn
                type="radio"
                setVal={(val) => setGenderWaysFilter(val)}
                name="examreportToggle"
                value={genderWaysFilter}
                icon={
                  <PersonInMobileIcon
                    fill="white"
                    style={{ width: "1.3rem", height: "1.3rem" }}
                  />
                }
                icontype="svg"
                label="Girls"
              />
            </div>
          </div>
        </div>
        <hr color="#b0b0b0" className="w-full" />
      </div>

      <div className="w-full flex-row align-left justify-start scroll-x pb-1">
        <div className="flex-row align-left justify-start g-1">
          {classInfoData?.map((data) => {
            return (
              <ClassInfoAndFormContainer _data={data} handelEdit={handelEdit} handelDelete={handelDeleteData} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Body;
